<template>
    <div class="panel modalDetailsPanel">
        <p>
                            
            <template v-for="panelmember in panelmembers">
                
                <strong>{{ panelmember.fullname }}</strong><br />
                {{ panelmember.organisation }}<br />
                <a :href="`mailto:${panelmember.email}`">{{ panelmember.email }}</a><br />
                {{ panelmember.phone }}<br /><br />
                    
            </template>

        </p>
    </div>
</template>

<script>
export default {
    props: {
        panelmembers: {
            type: Array,
            required: true
        }
    }
}
</script>


<style scoped>
p a {    color: var(--base-color-3);}
</style>